export default __webpack_public_path__ + "static/media/select-radio-active.599cc8cc.svg";